import { render, staticRenderFns } from "./finishedChallenges.vue?vue&type=template&id=383979f6&scoped=true"
import script from "./finishedChallenges.vue?vue&type=script&lang=js"
export * from "./finishedChallenges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383979f6",
  null
  
)

export default component.exports